$(document).on('click', 'input[id^=filters_qualification_validity]', function() {
  var ref;
  if (((ref = this.value) === 'all' || ref === 'none' || ref === 'only_expired') && $(this).is(':checked')) {
    $('input#filters_qualification_match_one').prop('checked', true);
    $('input#filters_qualification_match_all').prop('checked', false).attr('disabled', 'disabled');
    if (this.value === 'all') {
      $('fieldset#year-scope').show();
      $('fieldset#reference-date').hide();
    }
    if (this.value === 'none') {
      $('fieldset#year-scope').hide();
      $('fieldset#reference-date').hide();
    }
    if (this.value === 'only_expired') {
      $('fieldset#year-scope').hide();
      return $('fieldset#reference-date').show();
    }
  } else {
    $('fieldset#year-scope').hide();
    $('fieldset#reference-date').show();
    return $('input#filters_qualification_match_all').prop('checked', false).removeAttr('disabled');
  }
});
